import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { deleteFile } from './utils';

export default function* listenDeleteFile() {
  yield takeEvery(actions.deleteFile.type, deleteFile);
}
